
import { ReactNode, useState } from 'react'
import { InView } from 'react-intersection-observer'
import { useLocation } from 'react-router-dom'
import { useIsAdmin } from '../hooks/isAdmin'
import { useIsCourseAdmin } from '../hooks/isCourseAdmin'
import { useIsCenterManager } from '../hooks/isCenterManager'
import { useIsTeacher } from '../hooks/isTeacher'
import {
  Container,
  Icon,
  Menu,
  Segment,
  Sidebar,
} from 'semantic-ui-react'

import { PATHS } from '../paths';

import './ResponsiveContainer.css'

import { MediaContextProvider, Media } from '../mobile'

// TODO: add an alerts menu item here
const SharedMenu = () => {
  const isAdmin = useIsAdmin();
  const isCourseAdmin = useIsCourseAdmin();
  const isCenterManager = useIsCenterManager();
  const location = useLocation();

  return (
    <>
      <Menu.Item as='a' href={PATHS.CLASSES} active={location.pathname === PATHS.CLASSES}>
        Classes
      </Menu.Item>
      {isAdmin && <Menu.Item as='a' href={PATHS.CLASS_CREATE} active={location.pathname === PATHS.CLASS_CREATE}>
        Create classes
      </Menu.Item>}
      <Menu.Item as='a' href={PATHS.PEOPLE} active={location.pathname === PATHS.PEOPLE}>
        People
      </Menu.Item>
      {(isCenterManager || isCenterManager) && <Menu.Item as='a' href={PATHS.PEOPLE_CREATE} active={location.pathname === PATHS.PEOPLE_CREATE}>
        Create people
      </Menu.Item>}
      {isAdmin && <Menu.Item as='a' href={PATHS.TAGS} active={location.pathname === PATHS.TAGS}>
        Tags
      </Menu.Item>}
      {isAdmin && <Menu.Item as='a' href={PATHS.ADMIN_TOOLS} active={location.pathname === PATHS.ADMIN_TOOLS}>
        Admin
      </Menu.Item>}
      {isAdmin && <Menu.Item as='a' href={PATHS.GALLERY} active={location.pathname === PATHS.GALLERY}>
        Gallery
      </Menu.Item>}
      {isCourseAdmin && <Menu.Item as='a' href={PATHS.DASHBOARD} active={location.pathname === PATHS.DASHBOARD}>
        Dashboard
      </Menu.Item>}
      {(isCourseAdmin || isCenterManager) && <Menu.Item as='a' href={PATHS.ATTENDANCE} active={location.pathname === PATHS.ATTENDANCE}>
        Attendance
      </Menu.Item>}
      {/* <Menu.Item as='a'>Work</Menu.Item> */}
      <Menu.Item as='a' href={PATHS.LOGOUT}>Logout</Menu.Item>
  </>
  )
}

const DesktopContainer = ({ children }: { children: ReactNode }) => {
  const [fixed, setFixed] = useState(true);

  return (
    <Media greaterThan='mobile'>
      <InView
        threshold={1}
        onChange={() => setFixed(!fixed)}
      >
        <Segment
          inverted
          textAlign='center'
          vertical
        >
          <Menu
            fixed={fixed ? 'top' : undefined}
            inverted={!fixed}
            pointing={!fixed}
            secondary={!fixed}
            size='large'
          >
            <Container>
              <SharedMenu />
            </Container>
          </Menu>
        </Segment>
      </InView>
      <br/>
      {children}
    </Media>
  )
}

const MobileContainer = ({ children }: {children: ReactNode}) => {
  const isTeacher = useIsTeacher();
  const [sidebarOpened, setSideBarOpened] = useState(false);

  if (isTeacher) {
    return (
      <Media at='mobile'> {children} </Media>
    )
  }

  return (
    <Media at='mobile'>
      <Sidebar.Pushable>
        <Sidebar
          style={{'top': '44px'}}
          className='mobile-sidebar x y z win'
          as={Menu}
          animation='overlay'
          direction='right'
          inverted
          onHide={() => setSideBarOpened(false)}
          vertical
          visible={sidebarOpened}
        >
          <SharedMenu />
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            inverted
            textAlign='center'
            vertical
            className='mobile-menu'
          >
            <Container>
              <Menu inverted pointing secondary size='large'>
                <Menu.Item position='right' onClick={() => setSideBarOpened(true)}>
                  <Icon name='sidebar' />
                </Menu.Item>
              </Menu>
            </Container>
          </Segment>

          {children}
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    </Media>
  )
}

const ResponsiveContainer = ({ children }: {children: ReactNode}) => (
  <MediaContextProvider>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </MediaContextProvider>
)

export { ResponsiveContainer }
